import { render, staticRenderFns } from "./viewLGMUN.vue?vue&type=template&id=635886e0&scoped=true"
import script from "./viewLGMUN.vue?vue&type=script&lang=js"
export * from "./viewLGMUN.vue?vue&type=script&lang=js"
import style0 from "./viewLGMUN.vue?vue&type=style&index=0&id=635886e0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635886e0",
  null
  
)

export default component.exports